module.exports = __webpack_public_path__ + "static/img/sciserver_icon_groups.7ee05a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sciserver_icon_groups.png
// module id = Uvt9
// module chunks = 1